import React from "react";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import AccountBalanceWalletOutlinedIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import StorefrontActionButton from "../Storefront/ActionButton/StorefrontActionButton";
import "./CurrencySelectorV2.css";

const names = {
  kwd: ["Kuwaiti dinar", "دينار كويتي"], bhd: ["Bahraini dinar", "دينار بحريني"],
  qar: ["Qatari riyal", "ريال قطري"], sar: ["Saudi riyal", "ريال سعودي"],
  omr: ["Omani rial", "ريال عماني"], aed: ["UAE dirham", "درهم إماراتي"],
  usd: ["US dollar", "دولار أمريكي"], eur: ["Euro", "يورو"],
  gbp: ["British pound", "جنيه إسترليني"], jod: ["Jordanian dinar", "دينار أردني"],
};

export default function CurrencySelectorV2({ options, selected, onSelect, onConfirm, onClose, language, themeColor }) {
  const arabic = language === "arabic";
  return (
    <Dialog open onClose={onClose} aria-labelledby="sf-currency-title" aria-describedby="sf-currency-description"
      style={{ zIndex: 1600 }} PaperProps={{ className: "sf-currency-modal storefront-v2-surface", dir: arabic ? "rtl" : "ltr",
        style: { "--currency-accent": themeColor } }}>
      <header className="sf-currency__header">
        <span className="sf-currency__icon" aria-hidden="true"><AccountBalanceWalletOutlinedIcon /></span>
        <IconButton className="sf-currency__close" aria-label={arabic ? "إغلاق" : "Close"} onClick={onClose}><CloseRoundedIcon /></IconButton>
        <h2 id="sf-currency-title">{arabic ? "اختر العملة" : "Choose currency"}</h2>
        <p id="sf-currency-description">{arabic ? "اعرض الأسعار بالعملة التي تفضلها." : "View prices in your preferred currency."}</p>
      </header>
      <div className="sf-currency__options" role="group" aria-label={arabic ? "العملات المتاحة" : "Available currencies"}>
        {options.map(option => <button key={option.iso} type="button" className="sf-currency__option" aria-pressed={selected === option.code}
          onClick={() => onSelect(option.code)}>
          <span className="sf-currency__flag" aria-hidden="true">{option.flag && React.cloneElement(option.flag, { style: { width: 32, height: 32 } })}</span>
          <span className="sf-currency__label"><strong><bdi dir="ltr">{option.iso.toUpperCase()}</bdi></strong><small>{names[option.iso]?.[arabic ? 1 : 0] || option.iso.toUpperCase()}</small></span>
          <span className="sf-currency__check" aria-hidden="true">{selected === option.code && <CheckRoundedIcon />}</span>
        </button>)}
      </div>
      <footer className="sf-currency__footer">
        <StorefrontActionButton tone="secondary" onClick={onClose}>{arabic ? "إلغاء" : "Cancel"}</StorefrontActionButton>
        <StorefrontActionButton onClick={() => onConfirm(selected)} disabled={!options.some(option => option.code === selected)}>
          {arabic ? "تأكيد العملة" : "Apply currency"}
        </StorefrontActionButton>
      </footer>
    </Dialog>
  );
}
